import { gql } from "@apollo/client";

export const GET_PERMIT_STATS = gql`
  query GetPermitStats {
    activePermits: permit_aggregate(where: { status: { _eq: active } }) {
      aggregate {
        count
      }
    }
    expiredPermits: permit_aggregate(where: { status: { _eq: expired } }) {
      aggregate {
        count
      }
    }
    pendingPermits: permit_aggregate(where: { application_status: { _eq: pending } }) {
      aggregate {
        count
      }
    }
    awaitingInfoPermits: permit_aggregate(where: { application_status: { _eq: awaiting_additional_info } }) {
      aggregate {
        count
      }
    }
    deniedPermits: permit_aggregate(where: { application_status: { _eq: denied } }) {
      aggregate {
        count
      }
    }
    totalPermits: permit_aggregate(where: { status: { _neq: pending } }) {
      aggregate {
        count
      }
    }
  }
`;

export interface GetPermitStatsData {
  activePermits: {
    aggregate: {
      count: number;
    };
  };
  expiredPermits: {
    aggregate: {
      count: number;
    };
  };
  pendingPermits: {
    aggregate: {
      count: number;
    };
  };
  awaitingInfoPermits: {
    aggregate: {
      count: number;
    };
  };
  deniedPermits: {
    aggregate: {
      count: number;
    };
  };
  totalPermits: {
    aggregate: {
      count: number;
    };
  };
}
